module.exports = __webpack_public_path__ + "static/media/landmark.5297315c.svg";